<template>
    <nav>
        <!-- menu principal -->
        <v-app-bar app class="lindi darken-2" dark>
        <v-toolbar-title class="headline text-uppercase">
            <span>PLP/</span>
            <span class="font-weight-light">PRODUCCIÓN</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn class="ma-2" color="success" @click="goLogin">ingreso</v-btn> -->
        </v-app-bar>
    </nav>
</template>
<script>
export default {
    methods:{
        goLogin(){
            this.$router.push('/login');
        }
    }
}
</script>

<style>
.v-application .lindi.darken-1 {
    background-color: #5fa8d3 !important;
    border-color: #4c97c2 !important;
}

.v-application .lindi.darken-2 {
    background-color: #1a5a80 !important;
    border-color: #124868 !important;
}

</style>

